export default "__VITE_ASSET__Jrip1BxS__"